import 'debug';
import { d as pageMixin, _ as _asyncToGenerator, h as _regeneratorRuntime } from './index2.js';
import 'deepmerge';
import 'axios';
import Vue from 'vue';

var XpHomePage = Vue.extend({
  name: 'XpHomePage',
  mixins: [pageMixin],
  data: function data() {
    return {
      childrenPageData: [],
      contentPageData: null
    };
  },
  created: function created() {
    // this.$xp.history.addHomePage(this.$route.params.id, this.$route.path, this.pageData.Title)
    if (this.pageData.NfcPageId) {
      console.log('XpHomePage.created() set NfcPageID=', this.pageData.NfcPageId);
      window.localStorage.setItem('nfcPageId', this.pageData.NfcPageId);
    }
  },
  mounted: function mounted() {
    this.childrenPageData = JSON.parse(JSON.stringify(this.pageData.children));

    if (this.childrenPageData.length > 0) {
      // show nav only when tab items > 0
      this.$xp.navigation.preventAutoHide();
      this.$xp.navigation.showNav();
    } else if (this.childrenPageData.length === 1 && this.childrenPageData[0].Class === 'XpSplashScreen') {
      // hide navigation (splash screen is used for example)
      this.$xp.navigation.preventAutoHide();
      this.$xp.navigation.hideNav();
    } // this.$xp.navigation.setTabs(this.childrenPageData)


    if (this.childrenPageData.length > 1 && this.$route.query.activeTabId) {
      this.$xp.navigation.setActiveTabId(parseInt(this.$route.query.activeTabId));
    } else if (this.$xp.history.historyParams["homeActiveTab".concat(this.$route.params.id)]) {
      this.$xp.navigation.setActiveTabId(parseInt(this.$xp.history.historyParams["homeActiveTab".concat(this.$route.params.id)]));
    } else if (this.childrenPageData.length && !this.$xp.navigation.activeTab) {
      this.$xp.navigation.setActiveTabId(this.childrenPageData[0].ID);
    }

    this.loadContentPageData();
  },
  methods: {
    loadContentPageData: function () {
      var _loadContentPageData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.saveContentScroll();
                this.contentPageData = null;
                _context.next = 4;
                return this.$nextTick();

              case 4:
                _context.next = 6;
                return this.$xp.http.getPageData(this.$xp.navigation.activeTabId);

              case 6:
                data = _context.sent;
                this.contentPageData = data;
                _context.next = 10;
                return this.$nextTick();

              case 10:
                if (data.Class === 'XpPanorama' || data.Class === 'XpMap' || data.IsFullScreen) {
                  this.$xp.navigation.allowAutoHide();
                  this.$xp.navigation.showNav(true);
                } else {
                  this.$xp.navigation.preventAutoHide();
                  this.$xp.navigation.showNav();
                }

                this.setScrollFromHistory("homeContentScroll".concat(this.contentPageData.ID));

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loadContentPageData() {
        return _loadContentPageData.apply(this, arguments);
      }

      return loadContentPageData;
    }(),
    saveContentScroll: function saveContentScroll() {
      var scrollableElement = document.querySelector('div.js-page-content');
      console.log('SAVE SCROLL', scrollableElement.scrollTop);

      if (scrollableElement && this.contentPageData && this.contentPageData.ID) {
        this.$xp.history.setHistoryParam(this.$route.params.id, "homeContentScroll".concat(this.contentPageData.ID), scrollableElement.scrollTop);
      }
    },
    renderContent: function renderContent(h) {
      // <div :class="{ 'c-home-page__content': true, 'c-home-page__content--full-width': $xp.navigation.isNavHidden }">
      //   <dynamic-page v-if="contentPageData" :pageData="contentPageData"></dynamic-page>
      //   <div class="c-home-page__loading" v-else="">
      //       <i class="xp xp-spinner xp--large is-spinning"></i>
      //   </div>
      // </div>
      return h('div', {
        class: {
          'c-home-page__content': true,
          'c-home-page__content--full-width': this.$xp.navigation.isNavHidden
        }
      }, [this.contentPageData ? h('dynamic-page-in-page', {
        props: {
          pageData: this.contentPageData
        }
      }) : h('div', {
        class: 'c-home-page__loading'
      }, [h('i', {
        class: 'xp xp-spinner xp--large is-spinning'
      })])]);
    }
  },
  // beforeDestroy () {
  //   this.$xp.navigation.resetTabs()
  // },
  watch: {
    '$xp.navigation.activeTabId': {
      // immediate: true, this caused a problem on grassi, a deferred watch trigger caused old active tab to be loaded
      handler: function () {
        var _handler = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(newVal, oldVal) {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!(newVal && newVal !== oldVal)) {
                    _context2.next = 5;
                    break;
                  }

                  console.log("history: activeTabId wathcer in home ".concat(oldVal, " => ").concat(newVal));
                  _context2.next = 4;
                  return this.loadContentPageData();

                case 4:
                  this.$xp.history.setHistoryParam(this.$route.params.id, "homeActiveTab".concat(this.$route.params.id), newVal);

                case 5:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function handler(_x, _x2) {
          return _handler.apply(this, arguments);
        }

        return handler;
      }()
    }
  },
  render: function render(h) {
    return h('div', {
      class: 'c-home-page'
    }, [this.renderContent(h)]);
  }
});

export default XpHomePage;
